import React from 'react';
import { BrowserRouter, Switch, Route, NavLink, Link, Navbar, Routes, useNavigate, useLocation, useParams } from 'react-router-dom';
import axios, { CanceledError } from 'axios';

const DeleteTrip = () => {
    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const location = useLocation();

    const {id} = location.state;

    const Ok = (id) => {
        document.getElementById('loader').style.display = "inline-block";
        axios.get('https://api.thesscarpool.eu/api/Trips/CancelTripById/'+id, { headers: {"Authorization" : `Bearer ${token}`} })
        .then(res => {
            console.log(res);
            axios.get('https://api.thesscarpool.eu/api/Members/GetReservationsHistory', { headers: {"Authorization" : `Bearer ${token}`} })
            .then(res => {
                console.log(res.data);
                //setRoutes(routes => res.data);
                sessionStorage.setItem("PendingHistory",JSON.stringify(res.data));
                navigate("/SuccessfullRouteDelete");
            }).catch(err => {
                console.log(err);
            });
        }).catch(err => {
            console.log(err);
        });
    }

    const Cancel = () => {
        navigate("/PendingHistoryRoutes")
    }

    return(
        <div className='SuccessfullReservationMainDiv'>
            <h1>Είστε σίγουροι ότι θέλετε να διαγράψετε τo δρομολόγιο σας;</h1>
            <div id="loader" className="loader"></div>
            <div className='SuccessfullButton'>
                <button style={{right:"10px"}} onClick={() => Ok(id)}>Ναι</button>
                <button style={{left:"10px"}} onClick={() => Cancel()}>Ακύρωση</button>
            </div>
        </div>
    );
}

export default DeleteTrip;